// Team member routes - proxied through narrow UI-owned endpoints
export const TEAM_MEMBER_STATUS_PATH = '/api/tm-status'
export const TEAM_MEMBER_RECONNECT_PATH = '/api/tm-reconnect'

// Guest routes - explicit UI-owned proxy endpoints only.
export const GUEST_SESSION_PATH = '/api/guest/session'
export const GUEST_SUBMIT_PATH = '/api/guest/submit'
export const GUEST_BLOCK_PATH = '/api/guest/block'
export const GUEST_UPDATE_STATUS_PATH = '/api/guest/update'
export const GUEST_SPONSOR_STATUS_PATH = '/api/guest/status/'
export const GUEST_RESEND_EMAIL_PATH = '/api/guest/resend-email'
// Final step: exchanges the post-OTP grant token for the server-signed redirect.
export const GUEST_GRANT_PATH = '/api/guest/grant'
